import React from "react";
import { fileTypes } from "../../consts/consts";
import UploadFile from "../UploadFile/UploadFile";

export default class UploadFiles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentMaxFiles: 1,
            uploadManually: false,
        };

        this.increaseMaxFiles = this.increaseMaxFiles.bind(this);

    }
    
    componentDidMount() {
        const {items, data, initialFilesAmount} = this.props;
        let fileCount = initialFilesAmount ? initialFilesAmount : items.reduce((count, item) => data[item.name] ? ++count : count, 0)
        this.setState({currentMaxFiles: fileCount || 1})
    }

    increaseMaxFiles() {
        let currentMaxFiles = this.state.currentMaxFiles;
        const maxFiles = this.props.maxFilesAmount;

        if (currentMaxFiles + 1 <= maxFiles)
            this.setState({currentMaxFiles: currentMaxFiles + 1});
    }

    render() {
        const {data, items, handleChangeFile, viewMode, deleted, disabled, classNames, maxFilesAmount, canUploadManually, handleChangeInput} = this.props;
        const currentMaxFiles = this.state.currentMaxFiles;
        const uploadManually = this.state.uploadManually;
        const fileType = this.props.fileType ? this.props.fileType : fileTypes.Document;

        return (
            <React.Fragment>
                {
                    items.map((item,index) => {
                        if (index < currentMaxFiles)
                            return (
                                <UploadFile
                                    data={data}
                                    className={classNames}
                                    key={item.name}
                                    label={item.label}
                                    name={item.name}
                                    emptyText={item.emptyText}
                                    link={data[item.name]}
                                    disabled={disabled}
                                    deleted={deleted}
                                    viewMode={viewMode}
                                    handleChange={handleChangeFile}
                                    fileType={fileType}
                                    uploadManually={uploadManually}
                                    handleChangeInput={handleChangeInput}
                                    onUploadingChange={this.props.onUploadingChange}
                                />
                            );
                    })
                }
                {
                    currentMaxFiles < maxFilesAmount && !viewMode &&
                    <button
                        type='button'
                        className='button-new positive'
                        onClick={this.increaseMaxFiles}>
                        Add {fileType === fileTypes.Photo ? 'photo' : 'file'}
                    </button>
                }
                {
                    !viewMode && canUploadManually &&
                    <button
                        type='button'
                        className='button-new positive upload-type'
                        onClick={() => this.setState({uploadManually: !this.state.uploadManually})}>
                        Upload {uploadManually ? 'File' : 'Manually'}
                    </button>
                }
            </React.Fragment>
        );
    }
}
     